module.exports = __webpack_public_path__ + "4f91183385c0f36e5bda0ea34fa52ef5.svg";


//////////////////
// WEBPACK FOOTER
// ./markup/fonts/icon-font/iconFont.svg
// module id = 738
// module chunks = 0